/**
 * Engine factory — creates the appropriate streaming engine based on role.
 */

import { ChannelSenderEngine } from './channelSenderEngine.js';
import { ChannelReceiverEngine } from './channelReceiverEngine.js';
import type { Qr20WebrtcSessionContract } from '@tokenstreaming/transport-webrtc';
import type { StreamParams, EngineCallbacks, EngineRole, StreamingEngine } from './types.js';

export function createStreamingEngine(
  role: EngineRole,
  params: StreamParams,
  session: Qr20WebrtcSessionContract,
  signMessage: (message: string) => Promise<string>,
  callbacks: EngineCallbacks
): StreamingEngine {
  switch (role) {
    case 'sender':
      return new ChannelSenderEngine(params, session, signMessage, callbacks);
    case 'receiver':
      return new ChannelReceiverEngine(params, session, signMessage, callbacks);
    default:
      throw new Error(`Unknown engine role: ${role}`);
  }
}

export { ChannelSenderEngine } from './channelSenderEngine.js';
export { ChannelReceiverEngine } from './channelReceiverEngine.js';
export { SmoothDisplayEngine } from './smoothDisplay.js';
export { OnChainService } from './onChainService.js';
export { buildDistributionIntent, computeDistributionPayouts } from './distributionBuilder.js';
export type * from './types.js';
